import React from 'react';
import { Reveal } from './Reveal';
import { CheckIcon, XIcon } from 'lucide-react';
const FOR = ['Para quienes sufren por alguien que les "dio alas" y luego desapareció (Ghosting).', 'Para quienes están cansados de ser el "plan B" o la opción de medianoche.', 'Para personas atrapadas releyendo chats viejos buscando señales de esperanza.', 'Para quienes se sienten culpables por no poder superar una relación que no tuvo etiqueta.'];
const NOT_FOR = ['Personas en relaciones estables que buscan mejorar su matrimonio.', 'Quienes buscan tácticas de manipulación para que su ex regrese.', 'Quienes no están dispuestos a dejar de revisar las redes sociales del otro.'];
export function WhoFor() {
  return <section className="w-full bg-ink py-24" data-id="element-162">
      <div className="mx-auto max-w-5xl px-6" data-id="element-163">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-164">
          <Reveal data-id="element-165">
            <div className="h-full rounded-2xl border border-electric/20 bg-indigo-deep/40 p-8" data-id="element-166">
              <h2 className="font-display text-2xl font-semibold text-cream" data-id="element-167">
                Este eBook es para ti si…
              </h2>
              <ul className="mt-6 space-y-4" data-id="element-168">
                {FOR.map(t => <li key={t} className="flex gap-3" data-id="element-169">
                    <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-electric/20" data-id="element-170">
                      <CheckIcon className="h-4 w-4 text-electric" data-id="element-171" />
                    </span>
                    <span className="leading-relaxed text-muted" data-id="element-172">{t}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-173">
            <div className="h-full rounded-2xl border border-white/10 bg-white/[0.02] p-8" data-id="element-174">
              <h2 className="font-display text-2xl font-semibold text-cream" data-id="element-175">
                No es para ti si…
              </h2>
              <ul className="mt-6 space-y-4" data-id="element-176">
                {NOT_FOR.map(t => <li key={t} className="flex gap-3" data-id="element-177">
                    <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-white/5" data-id="element-178">
                      <XIcon className="h-4 w-4 text-muted" data-id="element-179" />
                    </span>
                    <span className="leading-relaxed text-muted" data-id="element-180">{t}</span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}